/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2018
	17-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_interactions_firstload = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	/**
	None yet
	**/
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	this.onready = function() {
		
		/*
		Trigger: modal and popup preloader
		*/
		images.preload();
		modal.onready();
		popup.onready();
		form.onready();
		if(pollConnection === 1) { poll_connection.onready(); }
		
		/*
		Trigger: onready classes
		*/
		specific_mobilemenu.onready();
		specific_header.onready();
		specific_accordeon.onready();
		specific_scroller.onready();
		specific_language_switcher.onready();

		/*
		GA4: Event - Click Tarieven
		*/
		$(document).on('click','.js-click-tarieven',function() {

			gtag('event','tarieven_click',{
			});

			//console.log('tarieven_click');

			// window.dataLayer = window.dataLayer || [];
			// window.dataLayer.push({
			//   'event': 'tarieven_click'
			// });

		});

		/*
		GA4: Event - Click Contact
		*/
		$(document).on('click','.js-click-contact',function() {

			gtag('event','contact_click',{
			});

			//console.log('contact_click');

			// window.dataLayer = window.dataLayer || [];
			// window.dataLayer.push({
			//   'event': 'contact_click'
			// });

		});

		/*
		Swiper: Init
		*/
		var swiper = new Swiper('.js-slideshow', {
		  
			loop: true,
			slidesPerView: "auto",

        	autoplay: {
	          delay: 5000,
	          disableOnInteraction: false,
	        },

		});

		/*
		Intro: Click more
		*/
		$(document).on('click','.js-click-intromore',function() {

			$(this).hide();
			
			$('.js-intromore').slideDown();

		});

		/*
		Popup: Open on load
		*/
		if(
			url[2] == 'tarieven' ||
			url[2] == 'pricing'
		) {
			popup.open(1,1,'pricing');			
		}

	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	// none
	
}).apply(specific_interactions_firstload); 